import React from 'react';
import Header from '../../components/js/Header.js';
import Intro from '../../components/js/Intro.js';

const LandingPage = () => {
    return (
        <div style={{width:'82%', margin: '0 auto'}}>
            <Header />
            <Intro />
        </div>
    )
}

export default LandingPage;